import { useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";
import storageUtils from "../utils/storageUtils";

export default function HanderComponen() {
  const [searchParams] = useSearchParams();

  useEffect(() => {

    const token = searchParams.get("user_token");
    if (token) {
      storageUtils.set("user_token", token);
    }
  }, [searchParams]);

}